var _path, _path2, _path3, _path4, _path5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 40,
    viewBox: "0 0 44 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2021 0.958372C16.6679 -2.32016e-05 14.5097 -0.267482 12.4108 0.297154C11.2557 0.60446 10.1789 1.15342 9.2517 1.90776C8.32446 2.6621 7.56788 3.60464 7.03195 4.67308C6.31501 6.08096 6.24443 8.42866 6.24814 9.4242C4.94734 9.56421 3.73676 10.1557 2.82689 11.0958C-0.178307 13.9747 1.1367 17.3848 2.54458 19.2087C1.58247 20.2451 -0.33061 22.734 0.0482907 25.8321C0.456909 29.1456 2.15082 31.3038 4.87741 32.0839C4.90342 32.9717 5.15973 35.0966 6.84992 36.6345C7.98699 37.6259 9.45392 38.156 10.9621 38.1203C11.2363 38.1193 11.5103 38.1044 11.7831 38.0758C11.9141 38.2728 12.0607 38.4592 12.2214 38.633C13.0609 39.5394 14.2459 40 15.7429 40C19.5394 40 20.873 36.7682 21.0475 35.0557V4.92568L21.0141 4.69909C20.9844 4.6025 20.2266 2.26966 18.2021 0.958372ZM15.7541 38.5141C14.6917 38.5141 13.8782 38.2169 13.3321 37.6337C12.3551 36.5899 12.4629 34.9183 12.4666 34.9183C12.4823 34.7212 12.4192 34.526 12.291 34.3755C12.1628 34.225 11.9801 34.1316 11.7831 34.1159C11.6855 34.1081 11.5873 34.1196 11.4942 34.1497C11.4011 34.1798 11.3148 34.228 11.2403 34.2915C11.0898 34.4196 10.9964 34.6023 10.9807 34.7994C10.9501 35.4245 11.014 36.0507 11.1701 36.6567C9.9643 36.727 8.77811 36.3276 7.86033 35.5423C6.9925 34.7015 6.46373 33.5713 6.37444 32.3662C6.57875 32.3662 6.78677 32.4034 7.00223 32.4108H7.24368C8.92051 32.3837 10.5812 32.0787 12.1582 31.5082C12.5709 31.6813 13.0284 31.7169 13.4629 31.6098C13.8975 31.5028 14.286 31.2586 14.571 30.9136C14.856 30.5686 15.0224 30.141 15.0455 29.694C15.0686 29.2471 14.9472 28.8046 14.6993 28.432C14.4514 28.0594 14.0901 27.7765 13.669 27.6252C13.2478 27.4739 12.7891 27.4622 12.3607 27.5918C11.9324 27.7214 11.5572 27.9855 11.2905 28.3449C11.0239 28.7044 10.8801 29.1401 10.8804 29.5876C10.8814 29.8415 10.928 30.0931 11.0178 30.3306C9.47251 30.8172 6.67162 31.3484 4.5208 30.3937C2.80832 29.6508 1.7942 28.0423 1.50074 25.6575C1.11441 22.4183 4.0156 19.8328 4.04532 19.8105C4.12092 19.7443 4.18229 19.6634 4.22571 19.5727C4.26913 19.482 4.29369 19.3835 4.29792 19.283C4.30147 19.1824 4.28453 19.0821 4.24813 18.9883C4.21173 18.8944 4.15663 18.8089 4.08618 18.737C3.94874 18.5921 0.742941 15.156 3.84844 12.1694C4.81055 11.2481 5.83581 10.8172 6.8945 10.8915C8.44353 11.0029 9.76597 12.1322 10.416 12.7897C10.0176 13.0511 9.72081 13.4412 9.5751 13.8949C9.42939 14.3486 9.44356 14.8385 9.61527 15.283C9.78698 15.7276 10.1058 16.0998 10.5187 16.3377C10.9316 16.5757 11.4136 16.6649 11.8843 16.5906C12.3549 16.5163 12.786 16.2829 13.1054 15.9293C13.4249 15.5757 13.6136 15.1234 13.64 14.6476C13.6664 14.1718 13.5289 13.7013 13.2505 13.3146C12.9721 12.9278 12.5695 12.6482 12.11 12.5223C12.0854 12.4583 12.0516 12.3982 12.0097 12.344C11.9316 12.2437 10.1969 10.0594 7.7266 9.52078C7.7266 8.49923 7.80089 6.419 8.34695 5.34916C8.79116 4.46503 9.41836 3.68552 10.1869 3.06235C10.9554 2.43919 11.8478 1.98664 12.8046 1.73475C14.4874 1.28155 16.2296 1.46357 17.3886 2.2288C18.3816 2.93752 19.1397 3.92725 19.5654 5.07056V21.5639C19.2409 21.1946 18.8657 20.8731 18.451 20.6092C16.5119 19.4056 15.4792 19.4428 15.2972 19.4651C15.1633 18.9946 14.8685 18.5861 14.4642 18.3108C14.0599 18.0354 13.5718 17.9108 13.085 17.9587C12.5982 18.0065 12.1437 18.2238 11.8007 18.5725C11.4577 18.9213 11.2481 19.3794 11.2084 19.8669C11.1687 20.3544 11.3015 20.8404 11.5835 21.2401C11.8655 21.6397 12.2789 21.9276 12.7516 22.0536C13.2242 22.1796 13.7261 22.1356 14.1696 21.9293C14.6131 21.723 14.9701 21.3676 15.1783 20.9249C15.2598 20.9441 15.3438 20.9504 15.4272 20.9435C15.4532 20.9435 16.1701 20.9435 17.656 21.8722C18.815 22.5928 19.4131 24.0119 19.5579 24.3982V34.9405C19.5171 35.3269 19.023 38.5141 15.7429 38.5141H15.7541Z",
    fill: "url(#paint0_linear_418_3866)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3076 0.523704V16.6084H26.8611V24.8885H26.3076V39.673C26.8194 39.821 27.3498 39.8948 27.8826 39.8922C28.707 39.9087 29.5238 39.7319 30.2675 39.3759V26.5638H29.6657V18.2986H30.2675V0.1188C28.9353 -0.108931 27.5661 0.0310622 26.3076 0.523704Z",
    fill: "url(#paint1_linear_418_3866)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.39 0.988106C23.3507 2.31797 22.5854 4.68053 22.5557 4.78082L22.5111 4.91455V34.844C22.6523 36.2221 23.5253 38.5587 25.7689 39.4874V24.8886H25.2117V16.6085H25.7689V0.776367C25.6389 0.843232 25.5089 0.910097 25.3975 0.988106H25.39Z",
    fill: "url(#paint2_linear_418_3866)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0178 19.1493C41.484 18.5096 41.8591 17.8083 42.1322 17.0654C42.6783 15.4903 42.8752 13.1649 40.6463 11.0252C39.7705 10.1092 38.6131 9.51286 37.3588 9.33134C37.3588 8.24293 37.2585 6.0884 36.5713 4.72881C36.2307 4.0587 35.8063 3.43459 35.3083 2.87146V11.7868H35.8618V21.2221H35.2897V37.474C35.7965 37.2373 36.2638 36.9241 36.6753 36.5453C38.2949 35.0594 38.6107 33.0275 38.6627 32.0542C40.6872 31.4376 42.9086 29.8254 43.3989 25.7615C43.7778 22.7006 42.0022 20.2526 41.0178 19.1493Z",
    fill: "url(#paint3_linear_418_3866)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8024 0.226562V18.2986H31.3076V26.5639H30.8024V39.0639C31.2081 38.7767 31.5581 38.4179 31.8351 38.0052C32.8235 38.1034 33.8214 37.9894 34.7623 37.6708V21.1961H34.2088V11.7607H34.7623V2.3068C33.7578 1.36059 32.5355 0.676708 31.2036 0.315716C31.0624 0.278568 30.9324 0.25628 30.8024 0.226562Z",
    fill: "url(#paint4_linear_418_3866)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_418_3866",
    x1: 11.6122,
    y1: -37.5669,
    x2: 10.4458,
    y2: 34.8811,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#544FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#9345FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AF40FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_418_3866",
    x1: 29.2088,
    y1: -37.2846,
    x2: 28.0424,
    y2: 35.1634,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#544FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#9345FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AF40FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_418_3866",
    x1: 25.1003,
    y1: -37.3514,
    x2: 23.9339,
    y2: 35.0966,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#544FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#9345FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AF40FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_418_3866",
    x1: 40.2006,
    y1: -37.1063,
    x2: 39.0342,
    y2: 35.3417,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#544FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#9345FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AF40FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_418_3866",
    x1: 33.6887,
    y1: -37.2103,
    x2: 32.5186,
    y2: 35.234,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#544FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#9345FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AF40FD"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.3730d1d94813482c355a8614d9f9cd3f.svg";
export { ForwardRef as ReactComponent };